import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const pdfGenerator = defineConnector({
  identifier: "pdfGenerator",
  name: "PDF Generator",
  tagLine: "Template-driven PDF generation API",
  logo,
  protocol: "http",
  tags: ["documents"],
  auth: customAuth("pdfGenerator"),
  steps: [
    {
      title: "Create your PDF Generator JWT credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In PDF Generator API, use your API key as the JWT issuer, your workspace identifier email address as the subject, and your API secret as the HS256 signing key. Send the resulting JWT as a bearer token.",
        },
      ],
    },
    {
      title: "Enter your PDF Generator details",
      items: [
        {
          kind: "url",
          label: "PDF Generator base URL",
          required: true,
          placeholder: "https://us1.pdfgeneratorapi.com",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "Workspace identifier email",
          required: true,
          target: { kind: "configuration", field: "workspaceIdentifier" },
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
        {
          kind: "input",
          label: "API secret",
          required: true,
          target: { kind: "secrets", field: "apiSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl || "https://us1.pdfgeneratorapi.com"}/api/v4/templates`,
  },
  defaultUrlPattern: ({ instanceUrl }) =>
    urlToPattern(instanceUrl, "https://[^/]*\\.pdfgeneratorapi\\.com/.*"),
});
